import { ACTION_TYPE } from "../../core/redux/actionType";
import { hasTrippedBreaker, updateBreaker } from "../../core/redux/api/circuitBreaker/module";
import { apiGetScriptVersions } from "../../core/redux/api/endpoints";
import { addError, addLoading, getLoading, removeLoadingAndError } from "../../core/redux/api/module";
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from "../../core/redux/api/reduxStandardApiAction";
import { IAppState } from "../../core/redux/IAppState";
import { assoc, isNilOrEmpty } from "../../language/module";
import { getResource } from "../../language/resources/getResource";
import { VersionResponse } from "./versionResponse";

export const KEY_ACTION = ACTION_TYPE.SCRIPT_VERSION_REQUEST;
export const ACTIONS    = [
  ACTION_TYPE.SCRIPT_VERSION_REQUEST,
  ACTION_TYPE.SCRIPT_VERSION_RESPONSE,
  ACTION_TYPE.SCRIPT_VERSION_ERROR,
];


/**
 * Creates an action to dispatch that updates the config on the server.
 * @param config the config being saved
 */
export const getScriptVersionAction = (resortAbbreviation: string) => makeApiAction(
  {
    method:   'GET',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: state => apiGetScriptVersions(resortAbbreviation),
    types:    ACTIONS.map(action => ({ type: action, meta: { resortAbbreviation } })) as RsaaTypes,
    bailout:  (state: IAppState) => hasTrippedBreaker(state, KEY_ACTION)
                                    || !!getLoading(state, ACTION_TYPE.SCRIPT_VERSION_REQUEST, KEY_ACTION),
  },
);

const reducer: ApiReducer<VersionResponse[]> = (state, action, error, isLoading, payload): IAppState => {
    const resort         = action.meta.resortAbbreviation;
    const appStateResort = state.selectedResort.resortAbbreviation;
  
    // Ignore the results if the response is for a previous query that didn't complete before the
    // user switched resorts  
    if (action.type === ACTION_TYPE.SCRIPT_VERSION_RESPONSE && !isNilOrEmpty(appStateResort) && appStateResort !== resort) {
      return state;
    }
  
    if (isLoading) {
      return addLoading(state, KEY_ACTION, KEY_ACTION);
    }
  
    const withBreaker = updateBreaker(state, KEY_ACTION, !!error);
  
    if (error) {
      return addError(
        withBreaker,
        KEY_ACTION,
        KEY_ACTION,
        error ?? getResource(state.locale, 'GET_SCRIPT_VERSION_ACTION_ERROR'),
      );
    };
  
    if (!payload){
      payload = [];
    }
  
    const noLoadingOrError = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);
  
    return assoc('scriptVersions', payload, noLoadingOrError);
}

export const scriptVersionReducer = makeApiReducer<VersionResponse[]>(ACTIONS, KEY_ACTION, reducer);